<script>
export default {
  name: "Finance"
}
</script>


<template>
  <div class="tab-content bg-light">
    <div class="tab-pane active " id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
      <h1>Рабочее пространство</h1>
      <div ref="xspreadsheet" id="xapp"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

// const xspreadsheet = ref(null);

const options = {
  // mode: 'read',
  style: {
    bgcolor: '#ffffff',        // цвет фона для всех ячеек
    align: 'left',           // выравнивание текста по центру
    valign: 'bottom',          // вертикальное выравнивание по центру
    textwrap: false,            // перенос текста в ячейке
    underline: false,          // подчеркнутый текст
    color: '#333',             // цвет текста
    font: {
      name: 'Arial',
      size: 11,
      bold: false,
      italic: false,
    }
  },
  view: {
    height: () => document.documentElement.clientHeight - 35,
  },
  cols: { len: 12 }
};
const firstRow = {
  cells: {
    0: {text: 'Отдел', style: 0},
    1: {text: 'Сотрудник', style: 0},
    2: {text: 'Оклад', style: 0},
    3: {text: 'Проценты', style: 0},
    4: {text: 'Процент уже оплаченный нам', style: 0},
    5: {text: 'Фиксируется ОФ', style: 0},
    6: {text: 'Другие выплаты', style: 0},
    7: {text: 'Осталось к выдаче', style: 0},
    8: {text: 'Выдано', style: 0},
    9: {text: 'ЗП фонд Экспедитора', style: 0},
    10: {text: 'Осталось к выдаче в т.ч. за прошлые периоды', style: 0},
    11: {text: 'Примечание', style: 0},
  },
  height: 100,
  mode: 'read'
};
const firstRowStyle = {
  bgcolor: '#10ff00',
  textwrap: true,
  color: '#000000',
  border: {
    top: ['thin', '#000000'],
    bottom: ['thin', '#000000'],
    right: ['thin', '#000000'],
    left: ['thin', '#000000'],
  },
  font: {
    name: 'Arial',
    size: 11,
    bold: true,
    italic: false,
  }
};

let rows = {0: firstRow};
onMounted(async () => {
  rows.len = 27;
  const s = x_spreadsheet('#xapp', options)
      .loadData([{
        name: 'Апрель 2024',
        // freeze: 'A2',
        styles: [
          firstRowStyle
        ],
        cols: {
          len: 12
        },
        rows
      },
        {
          name: 'Май 2024',
          freeze: 'A2',
          styles: [
            firstRowStyle
          ],
          cols: {
            len: 12
          },
          rows
        }
      ])
      .change(data => {
        // TODO
      });
})
</script>

<style scoped>

</style>